import { Injectable } from "@angular/core";
import { ApiService } from "../../api/api.service";
import { IAdmin_Achievement_Response, IAdmin_Achievements_Response, IAdmin_CreateAchievement_Request, IAdmin_DeleteAchievement_Response, IAdmin_UpdateAchievement_Request } from "../../../_models/achievements.model";


@Injectable({
    providedIn: "root",
})
export class AchievementsService {

    private readonly endpoint = 'dating/admin/achievements/achievements'
    constructor(private apiService: ApiService) { }

    getAchievements(includeDeleted: boolean = false, search: string = '') {
        let url = `${this.endpoint}?`;
        if (includeDeleted) url += `includeDeleted=true&`;
        if (search) url += `search=${encodeURIComponent(search)}&`;
        
        if (url.endsWith('&') || url.endsWith('?')) {
            url = url.slice(0, -1);
        }

        return this.apiService.get<IAdmin_Achievements_Response>({
            Url: url
        });
    }
    createAchievement(body: IAdmin_CreateAchievement_Request) {
        return this.apiService.post<IAdmin_CreateAchievement_Request, IAdmin_Achievement_Response>({
            Url: `${this.endpoint}`,
            Body: body
        });
    }

    updateAchievement(achievementId: string, body: IAdmin_UpdateAchievement_Request) {
        return this.apiService.put<IAdmin_UpdateAchievement_Request, IAdmin_Achievement_Response>({
            Url: `${this.endpoint}/${achievementId}`,
            Body: body
        });
    }
    deleteAchievement(achievementId: string) {
        return this.apiService.delete<{}, IAdmin_DeleteAchievement_Response>({
            Url: `${this.endpoint}/${achievementId}`,
            Body: {}
        });
    }

    bulkDeleteAchievements(ids: string[]) {
        return this.apiService.post<{ids: string[]}, any>({
            Url: `${this.endpoint}/bulk-delete`,
            Body: { ids }
        });
    }

}

